import { FC } from "react"
import { TravelersAddSuccess } from "../../../module/travelers/containers/addSuccess"

export const TravelersAddSuccessPage: FC = () => <TravelersAddSuccess />
